import clsx from "clsx";

import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";

type Props = {
	/**
	 * `figure` is the value line of a figure row, `sm` is a `text-sm` line (20 px), as on the cards. A card value
	 * is short and sits at the right end of its row, so the `sm` box has no minimum width, and the spinner sits
	 * in the middle of where the value shows.
	 */
	size?: "figure" | "sm";
};

// The box has the height of the value line (for `figure`, 28 px on a phone and 24 px from `lg`) and a minimum
// width, so a row does not jump when the value arrives.
export function LoadingValue({ size = "figure" }: Props) {
	return (
		<span className={clsx("flex items-center justify-center", size === "figure" ? "min-h-7 min-w-12 lg:min-h-6" : "h-5")}>
			<LoadingSpinner size="sm" theme="neutral" />
		</span>
	);
}
